import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaUsers} from "react-icons/fa";

function HousekeepingManpower(){

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "The Helper Ji housekeeping staff understood our routine in a few days. We don’t have to keep repeating instructions anymore.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Work is completed on time, and behavior is respectful. HelperJi's manpower has been reliable so far.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "Earlier, helpers used to change frequently. Since Helper Ji provided housekeeping manpower, attendance has been stable.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

  const services = [
      {
        name: "Housekeeping Manpower Services Gurugram",
        link: "/housekeeping-manpower-services-gurugram",
        icon: <FaUsers />
      },
      {
        name: "Housekeeping Manpower Services Ghaziabad",
        link: "/housekeeping-manpower-services-ghaziabad",
        icon: <FaUsers />
      },
      {
        name: "Housekeeping Manpower Services Delhi",
        link: "/housekeeping-manpower-services-delhi",
        icon: <FaUsers />
      }
    ];

    return(
        <Fragment>
          <Helmet>
          
           {/* BASIC META */}
    <title>
      Housekeeping Manpower Company in Noida | Corporate Manpower Services
    </title>
    <meta
      name="description"
      content="Hire professional housekeeping manpower services in Noida offering corporate housekeeping services, trained staff & reliable support from trusted housekeeping manpower agency."
    />
    <meta
      name="keywords"
      content="Housekeeping Manpower Services In Noida, Corporate Housekeeping Services, Housekeeping Services For Corporates, Housekeeping Company In Noida, Housekeeping Manpower Agency In Noida, Professional Housekeeping Manpower Services, Trained Housekeeping Staff In Noida"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/housekeeping-manpower-services-noida"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Housekeeping Manpower Company in Noida | Corporate Manpower Services"
    />
    <meta
      property="og:description"
      content="Hire professional housekeeping manpower services in Noida offering corporate housekeeping services, trained staff & reliable support from trusted housekeeping manpower agency."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/housekeeping1.png"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/housekeeping-manpower-services-noida"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Housekeeping Manpower Company in Noida | Corporate Manpower Services"
    />
    <meta
      name="twitter:description"
      content="Hire professional housekeeping manpower services in Noida offering corporate housekeeping services, trained staff & reliable support from trusted housekeeping manpower agency."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/housekeeping1.png"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/housekeeping-manpower-services-noida",
        "name": "Housekeeping Manpower Company in Noida | Corporate Manpower Services",
        "description": "Hire professional housekeeping manpower services in Noida offering corporate housekeeping services, trained staff & reliable support from trusted housekeeping manpower agency."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Housekeeping Manpower Services in Noida",
        "image": "https://www.helperji.in/assets/img/housekeeping1.png",
        "description": "Hire professional housekeeping manpower services in Noida offering corporate housekeeping services, trained staff & reliable support from trusted housekeeping manpower agency.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "548"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Housekeeping Manpower Services",
            "item": "https://www.helperji.in/housekeeping-manpower-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Housekeeping Manpower Services in Noida",
            "item": "https://www.helperji.in/housekeeping-manpower-services-noida"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What are corporate housekeeping services in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Corporate housekeeping services in Noida include professional cleaning and maintenance support for offices, IT parks, and commercial spaces to ensure hygiene and smooth operations."
            }
          },
          {
            "@type": "Question",
            "name": "Is Helper Ji a trusted housekeeping company in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji is a reliable housekeeping company in Noida offering trained and verified staff for corporate and commercial housekeeping needs."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide a housekeeping manpower agency near me in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji works as a dependable housekeeping manpower agency in Noida, supplying skilled manpower as per corporate requirements."
            }
          },
          {
            "@type": "Question",
            "name": "What type of housekeeping manpower services do you offer in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our housekeeping manpower services in Noida include floor cleaning, dusting, sanitizing, restroom cleaning, pantry cleaning, garbage management, furniture care, and glass cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "Is the housekeeping staff trained and verified?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, all housekeeping staff provided in Noida are trained, background-verified, and regularly supervised."
            }
          }
        ]
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>

          </Helmet>
            
            <Floatingcall />
         
            <section id="about" class="about">
            <div class="container" data-aos="fade-up">

            <div class="section-header">
            <h2>Housekeeping Manpower Services in Noida</h2>
            <p>Trusted Housekeeping Company in Noida</p>
             </div>

           <div class="row gy-4">
           <div class="col-lg-6">
            <img src="/assets/img/housekeeping1.png" class="img-fluid rounded-4 mb-4" alt="" />
            
            </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
             <p className="text-justify">If you are searching for corporate housekeeping services, a housekeeping manpower agency near me, or a reliable housekeeping company in Noida, Helper Ji is your trusted solution. We are a professional housekeeping manpower agency in Noida providing trained and verified staff for offices, corporate buildings, IT parks, and commercial establishments.</p>
              <p className="text-justify">Helper Ji specialises in housekeeping services for corporates and delivers end-to-end housekeeping manpower services to maintain hygiene, cleanliness, and operational efficiency in workplaces. As an experienced housekeeping manpower agency in Noida, we understand the daily cleaning requirements of corporate environments and deliver manpower accordingly.</p>
              <h4>Among the Housekeeping Manpower Services We Offer in Noida</h4>
              <p className="text-justify">Floor Cleaning and Maintenance Our housekeeping staff ensures regular and deep cleaning of office floors, including tiles, marble, wooden flooring, and carpets. As a leading housekeeping company in Noida, we focus on maintaining a clean and professional floor appearance at all times. </p>
              <p className="text-justify">Dusting and Sanitizing Our trained manpower performs detailed dusting and sanitizing of desks, workstations, furniture, electronics, storage units, and common areas. This is a core part of our corporate housekeeping services in Noida.</p>
              <p className="text-justify">Bathroom and Restroom Cleaning We provide daily restroom cleaning, sanitisation, deodorising, and restocking of essentials. Our housekeeping manpower services ensure hygienic and well-maintained washrooms for employees and visitors.</p>
              <p className="text-justify">From countertops to appliances, our housekeeping staff keeps pantry and kitchen areas clean, safe, and organised. This service is widely requested by corporates looking for housekeeping services for corporates in Noida.</p>
            </div>
          </div>
        </div>

      </div>
    </section>


    <section id="services" class="services sections-bg">
          <div class="container" data-aos="fade-up">
    
            <div class="row gy-4">
              
              <div class="col-lg-6">
                <div class="content ps-0 ps-lg-5">
                  <h2>
                  Why Choose Helper Ji – Housekeeping Manpower Agency in Noida?
                  </h2>
                  <p className="text-justify">Helper Ji is a trusted housekeeping company in Noida offering reliable corporate housekeeping services with a focus on quality, safety, and consistency.</p>
                <ul>
                  <li className="text-justify"><b>Skilled & Verified Manpower:</b> Trained professionals following hygiene and safety protocols.</li>

                  <li className="text-justify"><b>Customised Staffing Solutions:</b> Manpower as per office size and working hours.</li>
                  
                  <li className="text-justify"><b>Cost-effective Services:</b> Affordable housekeeping manpower services without quality compromise.</li>
                  
                  <li className="text-justify"><b>Compliant & Trusted Agency:</b> Adherence to labour laws and industry standards.</li>
                </ul>
                <p className="pt-4">If you are looking for a housekeeping manpower agency near me in Noida, Helper Ji is the right choice.</p>
                  <div class="text-center mt-3"><Link to='/contact-us' className="booknow" onClick={scrollToTop}>Book Now</Link></div>
                </div>
              </div>
              <div class="col-lg-6">
                <img src="/assets/img/housekeeping4.png" class="img-fluid rounded-4 mb-4" alt="" />
              </div>
            </div>
    
          </div>
        </section>

      <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

        

        <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            FAQs – Corporate Housekeeping Services in Noida
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                 What are corporate housekeeping services in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Corporate housekeeping services in Noida include professional cleaning and maintenance support for offices, IT parks, and commercial spaces. These services ensure hygiene, cleanliness, and smooth daily operations.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Is Helper Ji a trusted housekeeping company in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, Helper Ji is a reliable housekeeping company in Noida offering trained and verified staff for corporate and commercial housekeeping needs.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Do you provide a housekeeping manpower agency near me in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, Helper Ji works as a dependable housekeeping manpower agency near me in Noida, supplying skilled manpower as per corporate requirements.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  What type of housekeeping manpower services do you offer in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our housekeeping manpower services in Noida include floor cleaning, dusting, sanitizing, restroom cleaning, pantry cleaning, garbage management, furniture care, and glass cleaning.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Do you offer housekeeping services for corporates in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, Helper Ji specializes in housekeeping services for corporates in Noida, providing customized manpower solutions for offices of all sizes.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LandingPageClient />
      
           <section className="py-5 sections-bg">
                            <div className="container">
                              <div className="row mb-4">
                                <div className="col text-center">
                                  <h2 className="fw-bold">Other Locations</h2>
                                  <p className="text-muted">
                                    Explore our other locations of Housekeeping Manpower
                                    Services
                                  </p>
                                </div>
                              </div>
                      
                              <div className="row g-4">
                                {services.map((service, index) => (
                                  <div className="col-md-4 col-sm-6" key={index}>
                                    <Link
                                      to={service.link}
                                      className="text-decoration-none text-dark"
                                    >
                                      <div className="card h-100 shadow-sm border-0 service-card">
                                        <div className="card-body d-flex align-items-center">
                                          <div className="service-icon me-3">
                                            {service.icon}
                                          </div>
                                          <h6 className="mb-0 fw-semibold">
                                            {service.name}
                                          </h6>
                                        </div>
                                      </div>
                                    </Link>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </section>

        </Fragment>
    )
}

export default HousekeepingManpower;